<template>
    <div class="row">
        <div class="col-md-6" style="background:#eeecf1; height:100vh;">
            <div class="middle-box text-center loginscreen animated fadeInDown">
                <div style="text-align:left;">
                    <div>

                        <h1 class="logo-name"><img src="img/logo.png" alt="DM"
                                                   style="width:70%; padding-top: 20px; padding-bottom: 20px; "></h1>


                    </div>
                    <h3 style="font-color:black; font-size:20px;">Get Started absolutely free.</h3>
                    <!--<p>Perfectly designed and precisely prepared for the food industry.

                    </p>-->
                    <!--<p>Login in. To see it in action.</p>-->
                    <form class="m-t" role="form" @submit.prevent="login()" style="padding-top:20px;">
                        <div class="form-group">
                            <input type="text" v-model="user.username" class="form-control" placeholder="Username"
                                   required="">
                        </div>
                        <div class="form-group">
                            <input type="password" v-model="user.password" class="form-control" placeholder="Password"
                                   required="">
                        </div>
                        <button type="submit" class="btn btn-primary block full-width m-b">Login</button>

                        <!--<a href="#"><small>Forgot password?</small></a>-->
                    </form>
                    <p class="m-t"><small>Powered By <a target="_blank" href="https://septemsystems.com">SEPTEM
                        SYSTEMS</a> Private Limited &copy; 2018</small></p>
                </div>
            </div>
        </div>
        <div class="col-md-6" style="padding-top:80px; height:100vh; background-color:#622da7;">

            <div class="middle-box text-center loginscreen animated fadeInDown">

                <div style="text-align:left;">

                    <h3 style="font-size:36px; color:white; font-weight:700; letter-spacing: -0.22px;">Welcome Back<br>
                        hope you're crushing it.</h3>
                    <p style="    font-weight: 600; font-size: 16px;
    color: #fff;
    letter-spacing: -0.22px;
    line-height: 1.38462;
    margin: 14px 0 20px;
    opacity: .8;">Delivery Monsters perfectly designed and precisely prepared for food industry. It has proven track
                        record in optimizing internal business processes.</p>


                </div>
                <h1 class="logo-name"><img src="img/home.svg" alt="HRMS" style="width:100%"></h1>
            </div>


        </div>


    </div>


</template>

<script>
export default {
    name: "Login",
    data: function () {
        return {
            user: {
                username: "",
                password: ""
            }
        };
    },
    mounted: function () {
        if (this.$store.state.status === 'success' && this.$store.state.user.fullName !== undefined) {
            this.$router.push('/orders');
        }
    },
    methods: {
        login: async function () {
            this.$store.dispatch('login', this.user).then(async (resp) => {
                if (resp && resp.status === 200) {
                    const userRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
                    switch (userRole) {
                        // case 'AGENT': {
                        //     $("body").removeClass("gray-bg");
                        //     this.$router.replace("/orders")
                        //     break;
                        // }
                        case 'BRANCH': {
                            $("body").removeClass("gray-bg");
                            let user_branch= this.$store.state.user.branch;
                            if (user_branch && user_branch.isPortalEnabled) {
                                // await this.initFCM();
                                await this.$store.dispatch('validateUserAndCreateWebsocketConnection');
                                this.$router.replace("/branch_orders");
                            }else {
                              this.$router.replace("/point_of_sale");
                            }
                            break;
                        }
                        default: {
                            $("body").removeClass("gray-bg");
                            this.$router.replace("/orders");
                        }
                    }
                } else {
                    swal("ERROR!", "Sorry! Invalid Password, Contact DVM Tech Support To Get Access Of This Wonder World.", "error");
                }
            }).catch(ex => {
                console.error("Exception" + ex);
                swal("ERROR!", "Sorry! Invalid Password, Contact DVM Tech Support To Get Access Of This Wonder World.", "error");
            });
        },
        async initFCM() {
            await this.$store.dispatch("initFCM").then(messaging => {

                $("body").removeClass("gray-bg");
                this.$router.replace("/branch_orders");
            }).catch(ex => {
                swal("Warning", "Please allow notifications in browser!" + ex, "warning");
                console.error("Exception" + ex);
            });
        }
    }

}
</script>

<style scoped>

</style>
